module.exports = __webpack_public_path__ + "static/img/TG.f424f8e9.png";